import {Component} from '@angular/core';
import {Block}     from "../../block";

@Component({
    selector   : 'app-wysiwyg',
    templateUrl: './wysiwyg.component.html',
})
export class WysiwygComponent extends Block {

}
